import Actions            from 'Redux/Actions';
import { EventRepository } from 'Domain/Repositories';
import { ofType }         from 'redux-observable';
import { from }           from 'rxjs';
import { mergeMap }       from 'rxjs/operators';
import { TEpic }          from 'Redux/Config';

export const findEventEmployeesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventEmployeesRequest.type),
    mergeMap(action => from(
      EventRepository.findEmployees(action.payload.id)
        .then(({ userIds }: { userIds: string[] }) => Actions.findEventEmployeesSuccess({ userIds }))
        .catch((error: Error) => Actions.findEventEmployeesFailure({ error })),
    )),
  );
};
